import { Values } from '../types'
import { Box, Radio } from '@gassan-ui'
import { useFormikContext } from 'formik'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const AttendanceFields: FC = () => {
  const { t } = useTranslation('forms')
  const { setFieldValue, values } = useFormikContext<Values>()

  return (
    <Box
      mb="4"
      style={{ gap: '4px' }}
      display="flex"
      flexDirection={{ _: 'column', large: 'row' }}
      gridColumn="span 12"
    >
      <Radio
        name="attendance"
        value="true"
        id="attendance-will-attend"
        label={t('labels.willAttend')}
        onChange={() => setFieldValue('attendance', true)}
        checked={values.attendance === true}
        mb="0"
      />
      <Radio
        name="attendance"
        value="false"
        id="attendance-will-not-attend"
        onChange={() => setFieldValue('attendance', false)}
        label={t('labels.willNotAttend')}
        checked={values.attendance === false}
        mb="0"
      />
    </Box>
  )
}
